/**
 * Stable reason keys for negative feedback analytics.
 * Sent as the `reason` field when emitting AI_ASSISTANT_FEEDBACK_NEGATIVE.
 */
export const NEGATIVE_FEEDBACK_REASON = {
  NOT_WHAT_I_ASKED: 'not_what_i_asked',
  INCORRECT_OR_INCOMPLETE: 'incorrect_or_incomplete',
  HARD_TO_UNDERSTAND: 'hard_to_understand',
  NOT_HELPFUL_ENOUGH: 'not_helpful_enough',
  OTHER: 'other',
  NO_REASON_GIVEN: 'no_reason_given',
} as const

export type NegativeFeedbackReasonKey =
  (typeof NEGATIVE_FEEDBACK_REASON)[keyof typeof NEGATIVE_FEEDBACK_REASON]
